import { ReactNode, useEffect } from 'react';

interface Props {
    open: boolean;
    onClose: () => void;
    children: ReactNode;
}

const MobileCartDrawer = ({ open, onClose, children }: Props) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        // lock body scroll while drawer is open
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-[150] md:hidden"
            style={{
                background:
                    'radial-gradient(900px 560px at 50% 38%, rgba(139,109,255,0.18), transparent 70%), rgba(6,5,14,0.74)',
                backdropFilter: 'blur(22px) saturate(135%)',
                WebkitBackdropFilter: 'blur(22px) saturate(135%)',
                animation: 'fpResultIn 0.22s ease-out',
            }}
            onClick={onClose}
        >
            <div
                className="absolute inset-x-2 top-2 bottom-2 rounded-fl-lg flex flex-col overflow-hidden"
                style={{
                    background: 'linear-gradient(180deg, rgba(30,24,58,0.86), rgba(16,12,34,0.92))',
                    border: '1px solid color-mix(in srgb, #8b6dff 32%, transparent)',
                    boxShadow:
                        '0 36px 90px -24px rgba(0,0,0,0.75), 0 0 60px -18px rgba(139,109,255,0.45), inset 0 1px 0 rgba(255,255,255,0.07)',
                    animation: 'modalIn 0.28s cubic-bezier(0.34, 1.56, 0.64, 1)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between px-4 py-3 border-b border-stroke">
                    <span className="font-chat-nick inline-flex items-center gap-2.5 text-text_main font-extrabold tracking-[0.12em] uppercase text-[13px]">
                        <span
                            className="w-1 h-[22px] rounded-sm"
                            style={{
                                background: 'linear-gradient(#8b6dff,#3ad6ff)',
                                boxShadow: '0 0 12px #8b6dff',
                            }}
                        />
                        Cart
                    </span>
                    <button
                        onClick={onClose}
                        aria-label="Close"
                        className="w-9 h-9 grid place-items-center rounded-[28%] border border-stroke bg-white/[0.04] text-text_2 hover:rotate-90 hover:text-white hover:border-[#ff6262]/60 hover:bg-[rgba(255,98,98,0.12)] hover:shadow-[0_0_18px_-4px_rgba(255,98,98,0.7)] transition-all"
                    >
                        <svg
                            viewBox="0 0 24 24"
                            className="w-3.5 h-3.5 stroke-current fill-none [stroke-width:2.2] [stroke-linecap:round]"
                        >
                            <path d="M6 6l12 12M18 6l-12 12" />
                        </svg>
                    </button>
                </div>
                <div className="flex-1 min-h-0 overflow-auto">{children}</div>
            </div>
        </div>
    );
};

export default MobileCartDrawer;
